import axios from "axios";

import { apiBaseUrl } from './base';

export default axios.create({
    baseURL: apiBaseUrl
})